import Button from "@mui/material/Button";
import Replay from "@mui/icons-material/Replay";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";

const DEFAULT_BUTTON_PROPS = {
  variant: "contained",
  size: "large",
  sx: { fontSize: "16px", textTransform: "none" },
};

const VideoEndOverlay = ({ handleReplay, handleNavigationNext }) => {
  return (
    <div id="video-end-overlay">
      <div className="end-overlay-controls">
        <Button
          {...DEFAULT_BUTTON_PROPS}
          className="replay"
          onClick={handleReplay}
          startIcon={<Replay />}
        >
          Replay
        </Button>
        <Button
          {...DEFAULT_BUTTON_PROPS}
          className="next-slide"
          onClick={handleNavigationNext}
          endIcon={<PlayArrowIcon />}
        >
          Next Slide
        </Button>
      </div>
    </div>
  );
};

export default VideoEndOverlay;
